import { render, staticRenderFns } from "./ReadyToFinal.vue?vue&type=template&id=65ebec72&scoped=true&"
import script from "./ReadyToFinal.vue?vue&type=script&lang=js&"
export * from "./ReadyToFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebec72",
  null
  
)

export default component.exports